import { render, staticRenderFns } from "./ZonePricing.vue?vue&type=template&id=4929b0c8"
import script from "./ZonePricing.vue?vue&type=script&lang=js"
export * from "./ZonePricing.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports